export default `
<section class="second d-flex justify-content-center">
    <div class="mt-3">
        <img src="++{{section8Image}}">
    </div>
</section>
`
